import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  CompanySizeRequest,
  DataCollectionApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitCompanySize = createAsyncThunk<
  CompanySizeRequest,
  CompanySizeRequest,
  ThunkApi
>("submitCompanySize", async (companySizeData, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addCompanySize(companySizeData);
    return companySizeData;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio dimensione azienda",
      description:
        "Non siamo riusciti a salvare la dimensione della tua azienda.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
